
export function calculateSum(array: any[], key: string): number {
  return array.reduce((a: number, b: any) => a + (b[key] || 0), 0);
}

export function calculateSumLastNDays(array: any[], key: string, days: number): number {
  const now = new Date();
  const lastNDays = new Date(now.setDate(now.getDate() - days));
  return array.reduce((a: number, b: any) => {
    const date = new Date(b.createdAt);
    if (date > lastNDays) {
      return a + (b[key] || 0)
    }
    return a
  }, 0);
}
